import { TReflistQuestion } from '../../modules/api/repositories/reflists/reflists.types';

export const returnFirstAndLastAnswers = ({
  answers = [],
}: TReflistQuestion) => (_: any, questionIndex: number) =>
  questionIndex === 0 || questionIndex === answers.length - 1;

export function stripAccentuatedChars(accentuatedString: string) {
  return accentuatedString
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
